import { post } from '../utils/ApiUtil';
import { User } from '../common/model';
import type { EnumConfigOptionDTO } from './GlobalType';

const mock = false;

class ConfigEnumQueryParamDTO {
  deliveryConfigType!: number | null;
}

export const GlobalApi = {
  async getUserListByTeamId(): Promise<User[] | string> {
    if (mock && false) {
      return [];
    }
    return post<string, User[]>('/sparrowUser/getUserListByTeamId', '');
  },

  async getEnumConfigs(type: number): Promise<EnumConfigOptionDTO[] | string> {
    if (mock && false) {
      return [];
    }
    const param: ConfigEnumQueryParamDTO = { deliveryConfigType: type };
    return post<ConfigEnumQueryParamDTO, EnumConfigOptionDTO[]>('/sparrow/queryDeliveryConfigType', param);
  },

  async updateEnumConfigs(param: EnumConfigOptionDTO[]): Promise<boolean | string> {
    if (mock && false) {
      return true;
    }
    return post<EnumConfigOptionDTO[], boolean>('/sparrow/updateEnumMetadata', param);
  },
};
